import { render, staticRenderFns } from "./covid-19-painel-municipio.vue?vue&type=template&id=781c2dec&scoped=true&"
import script from "./covid-19-painel-municipio.vue?vue&type=script&lang=js&"
export * from "./covid-19-painel-municipio.vue?vue&type=script&lang=js&"
import style0 from "./covid-19-painel-municipio.vue?vue&type=style&index=0&id=781c2dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "781c2dec",
  null
  
)

export default component.exports